import axios from 'axios'
import config from '@/config'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: config.ApiRoot,
  timeout: 500000,
  responseType: 'blob'
})
// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  const token = getToken()
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})
export default service
